// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"d4e7ab93a39f2fdd9e73","303":"d928bdbcdec9dd07730f","495":"842406e9da1f0f56cebd"}[chunkId] + ".js";
};